// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import DynamicFormFieldSchema from './dynamic-form-field-schema';

const schema = {
  $id: '/dynamic-form-schema',
  type: 'object',
  required: [],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    description: {
      type: 'string',
      nullable: true,
    },
    formFields: {
      type: 'array',
      nullable: true,
      items: { ...DynamicFormFieldSchema },
    },
  },
} as IJSONSchema;

export default schema;
